import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatDialog } from '@angular/material/dialog';
import { KanbanViewCardI, KanbanViewListI } from '../../models/kanban-view/kanban-viewI';
import { KanbanAddEditSwimLaneComponent } from '../kanban-add-edit-swimlane/kanban-add-edit-swimlane.component';
import {CdkDragDrop, moveItemInArray, transferArrayItem} from '@angular/cdk/drag-drop';
import * as moment from 'moment';

@Component({
  selector: 'anterasoftware-kanban-view-container',
  templateUrl: './kanban-view-container.component.html',
  styleUrls: ['./kanban-view-container.component.scss'],
})
export class KanbanViewContainerComponent {

  @Input() public swimLaneList: KanbanViewListI[] = [];
  @Input() public dateFormatString: string = 'YYYY-MM-DD';
  @Input() public timeFormatString: string = 'hh:mm a';

  @Output() public onSwimLaneChange: EventEmitter<any> = new EventEmitter();
  @Output() public onDeleteSwimLane: EventEmitter<any> = new EventEmitter();
  @Output() public assignArtwork: EventEmitter<any> = new EventEmitter();
  @Output() public deleteArtwork: EventEmitter<any> = new EventEmitter();
  @Output() public selectClicked: EventEmitter<any> = new EventEmitter();
  @Output() public editArtwork: EventEmitter<any> = new EventEmitter();
  @Output() public onDrop: EventEmitter<any> = new EventEmitter();
  @Output() public onPin: EventEmitter<any> = new EventEmitter();
  @Output() public onOpenRelatedOrderDetailDialog: EventEmitter<any> = new EventEmitter();
  
  constructor(private dialog: MatDialog) {}

  /**
   * Opens the swim lane dialog for edit or add functionality.
   *
   * @param {KanbanViewListI} panel
   * @returns {void}
   */
  public openSwimLaneDialog(panel?: KanbanViewListI) {
    let dialogRef = this.dialog.open(KanbanAddEditSwimLaneComponent, {
      width: '500px',
      height: '450px',
      panelClass: 'antera-details-dialog',
      data: {
        panel: panel,
        swimlaneLength: this.swimLaneList.length
      },
    });

    dialogRef.afterClosed().subscribe((formValues: any) => {

      if (formValues) {
        this.onSwimLaneChange.emit(formValues);
      }
    });
  }

  /**
   * Deletes swimlane which is selected.
   *
   * @returns {void}
   */
  public deleteSwimLane(swimLane:any): void {
    if(swimLane.id) {
      this.onDeleteSwimLane.emit(swimLane);
    }
  }

  public onAssignArtwork(artwork:any): void {
    if(artwork) {
      this.assignArtwork.emit(artwork);
    }
  }

  public onDeleteArtwork(artwork:any): void {
    if(artwork) {
      this.deleteArtwork.emit(artwork);
    }
  }

  public onEditArtwork(artwork:any): void {
    if(artwork) {
      this.editArtwork.emit(artwork);
    }
  }

  /**
   * On change of card, we emit value.
   * 
   * @param {KanbanViewCardI} card 
   * @param {number} swimLaneIndex 
   * @param {number} cardIndex
   * @returns {void}
   */
  public cardValueChange(card: KanbanViewCardI, swimLaneIndex: number, cardIndex: number){
    // don't need this ngModel handles
    // this.swimLaneList[swimLaneIndex].cards[cardIndex] = card;
    //this.onSwimLaneChange.emit(this.swimLaneList);
    this.swimLaneList[swimLaneIndex].cards[cardIndex] = card;
    this.selectClicked.emit(this.swimLaneList);
  }

  /**
   * Toggles the all check box for each swim lane 
   * on and off.
   * 
   * @param {MatCheckbox} event 
   * @param {number} swimLaneIndex 
   * @returns {void}
   */
  public onToggleAll(event: MatCheckbox, swimLaneIndex: number){
    this.swimLaneList[swimLaneIndex]?.cards.forEach((card: KanbanViewCardI) => card.select = event.checked);
    this.selectClicked.emit(this.swimLaneList);
  }

  drop(event: any,swimLane:KanbanViewListI) {
    
    if(event && event.value) {
      let dropped =  {
        status: swimLane,
        artwork: event.value
      }
      
      this.onDrop.emit(dropped);
    }
    
  }

  pinned(cardDetails: any) {
    this.onPin.emit(cardDetails);
  }

  openRelatedOrderDetailDialog(cardDetails: any) {
    this.onOpenRelatedOrderDetailDialog.emit(cardDetails);
  }
}
